import random from 'toxilibs/random.js'
import Level from '../core/level.js'

// TODO: Python is not updated !

const level = new Level({
    name: 'for_simple',
    dependencies: [
        'levels/length',
        'levels/arrays_position2'
    ]
})


level.addQuestion({
    generator: function (q) {
        const i = random.intBetween(1, 20)

        q.addCode({
            javascript: 'let i = ' + i
                + '\n\ni = i + 1'
                + '\ni = i + 1'
                + '\n\ni'
        }, level.language)
    },
    times: 2,
    errorExpected: true,
    timeoutTime: 15000
})


level.addQuestion({
    generator: function (q) {
        let times = random.intBetween(3, 8)
        let jsCode = 'let i\n\ni = 0'

        for (let i = 0; i < times; i++) {
            jsCode += '\ni += 1'
        }

        jsCode += '\n\ni'

        q.addCode({
            javascript: jsCode
        }, level.language)
    },
    times: 2,
    errorExpected: true,
    timeoutTime: 15000
})


level.addQuestion({
    generator: function (q) {
        const count = random.intBetween(14, 300)
        q.addCode({
            javascript: 'let i'
                + '\n\nfor (i = 0; i < ' + count + '; i += 1) {'
                + '\n}'
                + '\n\ni',
            python: 'i'
                + '\n\nfor i in range (0, ' + count + ') :'
                + '\n\tpass'
                + '\n\ni'
        }, level.language)
    },
    times: 2,
    errorExpected: true,
    timeoutTime: 15000
})




level.addQuestion({
    generator: function (q) {
        const count = random.intBetween(10, 99)

        q.addCode({
            javascript: 'let counter = 100'

                + '\n\nfor (let i = 0; i < ' + count + '; i += 1) {'
                + '\n\tcounter += 1'
                + '\n}'

                + '\n\ncounter',
            python: 'a = 100'

                + '\n\nfor i in range (0, ' + count + ') :'
                + '\n\ta = a + 1'

                + '\n\na'
        }, level.language)
    },
    times: 2,
    timeoutTime: 15000
})





level.addQuestion({
    generator: function (q) {
        const a = [
            random.intBetween(2, 5),
            random.intBetween(1, 4),
            random.intBetween(2, 4)
        ]

        q.addCode({
            javascript: 'let array = ' + q.codeArrayToDisplay(a)
                + '\nlet sum   = 0'
                + '\n\nsum += array[0]'
                + '\nsum += array[1]'
                + '\nsum += array[2]'

                + '\n\nsum'
        }, level.language)
    },
    times: 2,
    timeoutTime: 15000
})



level.addQuestion({
    generator: function (q) {
        const a = [
            random.intBetween(2, 5),
            random.intBetween(1, 4),
            random.intBetween(2, 4)
        ]

        q.addCode({
            javascript: 'let array = ' + q.codeArrayToDisplay(a)
                + '\nlet sum   = 0'
                + '\nlet i     = 0'
                + '\n\nsum += array[i]'
                + '\n\ni = 1'
                + '\nsum += array[i]'
                + '\n\ni = 2'
                + '\nsum += array[i]'

                + '\n\nsum'
        }, level.language)
    },
    times: 2,
    timeoutTime: 15000
})



level.addQuestion({
    generator: function (q) {
        const a = [
            random.intBetween(2, 5),
            random.intBetween(1, 4),
            random.intBetween(2, 4)
        ]

        q.addCode({
            javascript: 'let array = ' + q.codeArrayToDisplay(a)
                + '\nlet sum   = 0'
                + '\nlet i     = 0'
                + '\n\nsum += array[i]'
                + '\n\ni += 1'
                + '\nsum += array[i]'
                + '\n\ni += 1'
                + '\nsum += array[i]'

                + '\n\nsum'
        }, level.language)
    },
    times: 2,
    timeoutTime: 15000
})



level.addQuestion({
    generator: function (q) {

        const a = [
            random.intBetween(2, 4),
            random.intBetween(1, 3),
            random.intBetween(1, 3),
            random.intBetween(2, 4)
        ]


        const sum = random.pick(1, 10, 100)

        q.addCode({
            javascript: 'let array = ' + q.codeArrayToDisplay(a)
                + '\nlet sum   = 0'
                + '\n\nfor (let i = 0; i < array.length; i += 1) {'
                + '\n\tsum += array[i]'
                + '\n}'

                + '\n\nsum',
            python: 'a = ' + q.codeArrayToDisplay(a)

                + '\n\nfor i in range (0, len(a)) :'
                + '\n\ta[i] = a[i] + ' + sum

                + '\n\na[0]'
        }, level.language)
    },
    times: 2,
    timeoutTime: 15000
})


const randomLetter = random.unmistakableLetter

level.addQuestion({
    generator: function (q) {
        const a = [
            randomLetter(),
            randomLetter(),
            randomLetter()
        ]

        q.addCode({
            javascript: 'let array  = ' + q.codeArrayToDisplay(a)
                + "\nlet string = ''"
                + '\n\nstring += array[0]'
                + '\nstring += array[1]'
                + '\nstring += array[2]'

                + '\n\nstring'
        }, level.language)
    },
    times: 2,
    timeoutTime: 15000
})



level.addQuestion({
    generator: function (q) {
        const a = [
            randomLetter(),
            randomLetter(),
            randomLetter(),
            randomLetter()
        ]

        q.addCode({
            javascript: 'let array  = ' + q.codeArrayToDisplay(a)
                + "\nlet string = ''"
                + '\n\nfor (let i = 0; i < array.length; i += 1) {'
                + '\n\tstring += array[i]'
                + '\n}'

                + '\n\nstring',
            python: 'a = ' + q.codeArrayToDisplay(a)
                + "\nb = '" + a[3] + "'"

                + '\n\nfor i in range (0, len(a)) :'
                + '\n\tb = b + a[i]'

                + '\n\nb'
        }, level.language)
    },
    times: 2,
    timeoutTime: 15000
})



export default level

